import styled from "styled-components"

import { styledColor } from "meditopia-ui/utils"

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  gap: 8px;
`

export const CheckboxContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
`

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
  transition: 0.2s ease-in;
`

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid ${styledColor("white.48", "gray.300")};
  background: ${(props) =>
    props.checked
      ? styledColor("secondary.main", "primary.main")(props)
      : "transparent"};
  transition: 0.2s ease-in;

  ${HiddenCheckbox}:focus + & {
    outline: 3px solid ${styledColor("secondary.main")}56;
  }

  ${Icon} {
    visibility: ${(props) => (props?.checked ? "visible" : "hidden")};
  }
`

export const CheckboxLabel = styled.span`
  flex: 1;
  color: ${styledColor("white.72", "gray.600")};
  font-size: 14px;
  line-height: 1.4;
`
